module.exports = __webpack_public_path__ + "static/img/pttd_10@2x.d4682e33.png";